<template>
  <div class="yn-radio" :class="{disable}">
    <b-form-radio-group
        :id="def.guid" :disabled="disable"
        v-model="def.val"  :chain="def.chain"
        :options="options"
    />
  </div>
</template>

<script>
import fieldmix from '@/components/fields/fieldmix';

export default {
  data: () => {
    return {
      options: [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
      ]
    };
  },
  mixins: [fieldmix],
  name: 'fieldtype_yn-radio'
};
</script>

<style lang="scss">
div.yn-radio{
  &.disable{
    pointer-events: none;
  }
  div.custom-control {
    &.custom-control-inline {
      margin-right: 25px;
    }
  }
}
</style>
